<template>
    <v-container>
        <v-data-table :headers="headers" :items="items" :search="search" class="elevation-1">
            <template v-slot:top>
                <v-toolbar flat>
                    <v-toolbar-title>Projekty</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Vyhladat" single-line
                        hide-details></v-text-field>
                    <v-spacer></v-spacer>
                    <v-dialog v-model="dialog" max-width="700px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
                                Novy projekt
                            </v-btn>
                        </template>
                        <v-card>
                            <v-card-title>
                                <span class="text-h5">{{ formTitle }}</span>
                            </v-card-title>
                            <v-card-text>
                                <v-container>
                                    <v-row>
                                        <v-col cols="12" sm="4">
                                            <v-text-field v-model.number="editedItem.order" label="Poradie"
                                                type="number"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="8">
                                            <v-text-field v-model="editedItem.name" label="Meno"></v-text-field>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-textarea v-model="editedItem.description"
                                                label="Popis"></v-textarea>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field v-model="editedItem.category" label="Ikona"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" class="d-flex align-center">
                                            <v-switch
                                                v-model="editedItem.is_global"
                                                label="Globálny projekt"
                                                inset
                                                hide-details
                                            />
                                        </v-col>
                                        <!-- <v-col cols="12" sm="6">
                                            <v-text-field v-model.number="editedItem.year1" label="Rok 1"
                                                type="number"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field v-model.number="editedItem.year2" label="Rok 2"
                                                type="number"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field v-model.number="editedItem.year3" label="Rok 3"
                                                type="number"></v-text-field>
                                        </v-col> -->
                                        <!-- <v-col cols="12" sm="6">
                                            <v-text-field v-model.number="editedItem.expected_profit_year_1"
                                                label="Ocakavany zisk R1" type="number"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field v-model.number="editedItem.expected_profit_year_2"
                                                label="Ocakavany zisk R2" type="number"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field v-model.number="editedItem.expected_profit_year_3"
                                                label="Ocakavany zisk R3" type="number"></v-text-field>
                                        </v-col> -->
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" text @click="close">Zrusit</v-btn>
                                <v-btn color="blue darken-1" text @click="save">Ulozit</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-toolbar>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
                <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
            </template>
            <template v-slot:item.is_global="{ item }">
                <v-chip :color="normalizeBoolean(item.is_global) ? 'success' : 'grey'" small outlined>
                    {{ normalizeBoolean(item.is_global) ? 'Áno' : 'Nie' }}
                </v-chip>
            </template>
        </v-data-table>
    </v-container>
</template>

<script>
import { APIService } from "@/http/APIService.js";
const apiService = new APIService();

export default {
    data: () => ({
        dialog: false,
        search: '',
        headers: [
            { text: 'Poradie', value: 'order' },
            { text: 'Meno', value: 'name' },
            { text: 'Ikona', value: 'category' },
            { text: 'Globálny', value: 'is_global' },
            // { text: 'Rok 1', value: 'year1' },
            // { text: 'Rok 2', value: 'year2' },
            // { text: 'Rok 3', value: 'year3' },
            { text: 'Akcie', value: 'actions', sortable: false },
        ],
        items: [],
        editedIndex: -1,
        editedItem: {
            order: 0,
            name: '',
            description: '',
            category: '',
            year1: 0,
            year2: 0,
            year3: 0,
            expected_profit_year_1: 0,
            expected_profit_year_2: 0,
            expected_profit_year_3: 0,
            is_global: false
        },
        defaultItem: {
            order: 0,
            name: '',
            description: '',
            category: '',
            // year1: 0,
            // year2: 0,
            // year3: 0,
            expected_profit_year_1: 0,
            expected_profit_year_2: 0,
            expected_profit_year_3: 0,
            is_global: false
        },
    }),

    computed: {
        formTitle() {
            return this.editedIndex === -1 ? 'New Project' : 'Edit Project';
        },
    },

    watch: {
        dialog(val) {
            val || this.close();
        },
    },

    created() {
        this.initialize();
    },

    methods: {
        initialize() {
            apiService.getAdminInvestmentProjects('', '', 100, 0).then(response => {
                const results = response && Array.isArray(response.results) ? response.results : [];
                this.items = results.map(item => ({
                    ...item,
                    is_global: this.normalizeBoolean(item.is_global)
                }));
            });
        },

        editItem(item) {
            this.editedIndex = this.items.indexOf(item);
            this.editedItem = Object.assign({}, item, {
                is_global: this.normalizeBoolean(item.is_global)
            });
            this.dialog = true;
        },

        deleteItem(item) {
            if (confirm('Naozaj chcete zmazat?')) {
                apiService.deleteAdminInvestmentProject(item).then(() => {
                    this.initialize();
                });
            }
        },

        close() {
            this.dialog = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },

        save() {
            const payload = {
                ...this.editedItem,
                is_global: this.normalizeBoolean(this.editedItem.is_global)
            };

            if (this.editedIndex > -1) {
                apiService.updateAdminInvestmentProject(payload).then(() => {
                    this.initialize();
                });
            } else {
                apiService.createAdminInvestmentProject(payload).then(() => {
                    this.initialize();
                });
            }
            this.close();
        },

        normalizeBoolean(value) {
            return value === true || value === 1 || value === '1' || value === 'true';
        }
    },
};
</script>
